import React from 'react';

interface FormCheckboxProps {
  label: React.ReactNode;
  name: string;
  checked?: boolean;
  onChange: (name: string, checked: boolean) => void;
}

const FormCheckbox = ({ label, name, checked, onChange }: FormCheckboxProps) => (
    <label htmlFor={name} className="flex items-center gap-3 p-3 bg-white rounded-lg border border-gray-200 cursor-pointer hover:border-blue-300 transition has-[:checked]:border-blue-500">
        <input type="checkbox" id={name} name={name} checked={!!checked} onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(name, e.target.checked)}
            className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
        <span className="text-sm font-medium text-gray-800">{label}</span>
    </label>
);

export default FormCheckbox;
